import { defineFcm } from '../shared/factory';

export const FCM_CORGI_PERIMETERX_SENSOR_SCRIPT_ENABLED = defineFcm('corgi_perimeterx_sensor_script_enabled')
	.asBoolean()
	.withDefault(true) // enabled by default for security
	.toConfig();
